import React, { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'
import ReactJson from 'react-json-view'
import TextualAdvice from "./TextualAdvice"

import { processLink } from '../../../classes/lib-common'
import Chai from './Chai';
import { useSelector } from 'react-redux';
const { $ , convertMarkdownToHtml} = window

export const getAdviceExclusionsTypes = (exclusions) => {
	const types = []
	for (const exclusion of exclusions) {
		if(!types.includes("advice") && exclusion.uuid){
			types.push("advice")
		}
		if(!types.includes("cve") && exclusion.cve){
			types.push("cve")
		}
		if(!types.includes("library") && exclusion.library){
			types.push("library")
		}
	}
	return types
}

const Exclusion = ({ advice, report, openTab, id, shouldShow, removeMitigations }) => {
	if (!shouldShow.exclusion) return null
	const isGlobalExclusionAvailable = shouldShow.globalExclusion
	const severityClass = "level-" + (shouldShow.exclusion ? "severity" : advice.severity.toLowerCase())

	const exclusionElement = {
		domain: "security",
		uuid: advice.exclusions[0].id,
		library: advice.library.name,
		language: advice.library.language,
		version: report.dependency.version,
		cve: advice.cve && advice.cve !== "N/A" ? advice.cve : null,
		report,
		choices: getAdviceExclusionsTypes(advice.exclusions)
		
	}
	const severity = advice.severity === "NONE" ? "INFO" : advice.severity
	return (<div className={"tab-pane fade report-box-text" + (openTab === "exclusion" ? " show active" : "")} id={"mitigation-reason-" + id} role="tabpanel" aria-labelledby={"mitigation-reason-tab-" + id} >
		Reason: <strong>{advice.exclusions[0].reason}</strong>
		{shouldShow.actions ?
			<button className="btn btn-primary btn-action issue-demitigate"
				title={advice.exclusions[0].readonly ?
					"This exclusion is embedded in the codebase on the '.meterian' file, and therefore it cannot be removed from this UI."
					: "This action is available only to authorized roles"
				}
				disabled={advice.exclusions[0].readonly}
				onClick={() => removeMitigations(exclusionElement, isGlobalExclusionAvailable)}>
				Remove
			</button> :
			""
		}
		<p>{advice.exclusions[0].description}</p>
		<p className="threat-description mt-5 severity">THREAT: <strong className={severityClass}>{severity}</strong> </p>
	</div>)
}

export const Description = ({ advice, openTab, id, name, report, shouldShow }) => {
	const severityClass = "level-" + (shouldShow.exclusion ? "severity" : advice.severity.toLowerCase())

	const clipboard = React.createRef();
	const copyToClipboardSuccess = () => {
		clipboard.current.classList.add("pop")
		setTimeout(() => {
			clipboard.current.classList.remove("pop")
		}, 300)
	}

	

	if (!advice.description) advice.description = "";

	const purifiedDescription = convertMarkdownToHtml(advice.description, DOMPurify)

	const severity = advice.severity === "NONE" ? "INFO" : advice.severity


	return (
		<div className={"tab-pane fade report-box-text advice-description position-relative" + (openTab === "description" ? " show active" : "")} id={"description-" + id} role="tabpanel" aria-labelledby={"description-tab-" + id}>
			{advice.cve || advice.cvss || advice.epss || advice.kevEntry?
				<div className="mb-2">
					
					{advice.cve && advice.cve !== "N/A" ?
						<b className="mr-3">
							<a className="text-link" href={"https://nvd.nist.gov/vuln/detail/" + advice.cve} rel="noopener noreferrer" target="_blank">{advice.cve}</a>
						</b>
						: null
					}
					{advice.epss ?
						<a className="text-link mr-3 " href={"https://www.first.org/epss/model"} rel="noopener noreferrer" target="_blank"><span className='badge badge-score'>EPSS: {Math.trunc(advice.epss * 10000) / 100}%</span></a>
						: null
					}
					{advice.cvss ?
						<span className="badge badge-score mr-3">CVSS: {advice.cvss}</span>
						: null
					}
					{advice.kevEntry ?
						<a className="text-link mr-3 " href={"https://www.cisa.gov/known-exploited-vulnerabilities-catalog?search_api_fulltext="+advice.kevEntry.cve} rel="noopener noreferrer" target="_blank">
							<span className='badge badge-kev  badge-left'>KEV</span>
							{advice.kevEntry.exploited ?
								<span className='badge badge-kev badge-critical badge-right'>Exploited</span> 
								: 
								<span className='badge badge-kev badge-medium  badge-right'>Listed</span>
							}
						</a>
						: null
					}
					<br />
				</div> : null}
			<span className="advice-description" dangerouslySetInnerHTML={{ __html: purifiedDescription }}></span><p className="threat-description mt-5">{advice.type && advice.type.toLowerCase() === "security" ? <React.Fragment>THREAT: <strong className={severityClass}>{severity}</strong> </React.Fragment> : "SUGGESTION"}</p>
			<i className="far fa-copy clipboard" 
				tabIndex={0} 
				onClick={() => { window.copyToClipboard(TextualAdvice(name, advice, report)); copyToClipboardSuccess() }}
				onKeyUp={(e) => { if(e.key.toLowerCase()!="enter") return;  window.copyToClipboard(TextualAdvice(name, advice, report)); copyToClipboardSuccess() }} ref={clipboard}></i>
		</div>
	)
}

export const LinksList = ({ id, links }) => {
	return (
		links.length ?
			<ul>
				{
					links.map((link, index) => {
						const processedLink = processLink(link.url, link.type);
						return (
							<li key={link.url + id + index}><a href={processedLink} target="_blank" rel="noopener noreferrer">{processedLink}</a></li>
						)

					})
				}
			</ul> :
			""
	)

}

export const FixedInVersions = ({advice, hasSafeVersion}) => {
	if ( !advice.fixedInVersions || !advice.fixedInVersions.length) return ""

	const withSafeVersionSingle = [
		`Despite the fixes in version ${advice.fixedInVersions}, keep in mind that other vulnerabilities might still be present. To ensure the best protection, consider updating to the latest safe version.`,
		`While version ${advice.fixedInVersions} addresses the vulnerability, it's crucial to mention that this version could still be affected by other vulnerabilities. For optimal security, it's advisable to switch to the latest safe version.`,
		`Although this vulnerability has been resolved in version ${advice.fixedInVersions}, please take into account that other vulnerabilities might still be unresolved. We recommend updating to the latest safe version for the highest level of security.` 
	]

	const withoutSafeVersionSingle = [
		`While version ${advice.fixedInVersions} claims to have patched this vulnerability, there are no known versions of this library that can be considered entirely safe. We strongly recommend finding an alternative.`,
		`The reported vulnerability has been addressed in version ${advice.fixedInVersions}, but it's essential to understand that there are no identified secure releases of this library. Our recommendation is to explore alternative solutions.`,
		`Version ${advice.fixedInVersions} has fixed the reported vulnerability, but it's crucial to emphasize that no safe versions of this library have been identified. We strongly advise seeking a replacement.`
	]
	
	const multiFixedVersions = [advice.fixedInVersions.slice(0, advice.fixedInVersions.length-1).join(", "),advice.fixedInVersions.at(-1)].join(" and ")

	const withSafeVersionMultiple = [
		`Despite the fixes in versions ${multiFixedVersions}, keep in mind that other vulnerabilities might still be present. To ensure the best protection, consider updating to the latest safe version.`,
		`While versions ${multiFixedVersions} address the vulnerability, it's crucial to mention that these versions could still be affected by other vulnerabilities. For optimal security, it's advisable to switch to the latest safe version.`,
		`Although this vulnerability has been resolved in versions ${multiFixedVersions}, please take into account that other vulnerabilities might still be unresolved. We recommend updating to the latest safe version for the highest level of security.`
	]
	
	const withoutSafeVersionMultiple = [
		`While versions ${multiFixedVersions} claim to have patched this vulnerability, there are no known versions of this library that can be considered entirely safe. We strongly recommend finding an alternative.`,
		`The reported vulnerability has been addressed in versions ${multiFixedVersions}, but it's essential to understand that there are no identified secure releases of this library. Our recommendation is to explore alternative solutions.`,
		`Versions ${multiFixedVersions} have fixed the reported vulnerability, but it's crucial to emphasize that no safe versions of this library have been identified. We strongly advise seeking a replacement.`
	]
	  
	console.log({hasSafeVersion, multiFixedVersions})

	const randomIndex = Math.floor(Math.random() * withSafeVersionSingle.length);
	if ( advice.fixedInVersions.length > 1 ) return <>{hasSafeVersion ? withSafeVersionMultiple[randomIndex] : withoutSafeVersionMultiple[randomIndex]}<br/><br/></>
	return <>{hasSafeVersion ? withSafeVersionSingle[randomIndex] : withoutSafeVersionSingle[randomIndex]}<br/><br/></>
	// 
	// return advice.fixedInVersions && advice.fixedInVersions.length ? ("The issue is fixed in version: " + advice.fixedInVersions.join(", ")) : ""
}
const Links = ({ advice, hasSafeVersion, openTab, id }) => {
	return (
		<div className={"tab-pane fade report-box-text" + (openTab === "info" ? " show active" : "")} id={"info-" + id} role="tabpanel" aria-labelledby={"info-tab-" + id}>
			<FixedInVersions advice={advice} hasSafeVersion={hasSafeVersion}/>
			<LinksList id={id} links={advice.links} />
		</div>
	)
}

const Hierarchy = ({ openTab, id, report, newMitigations }) => {

	const HierarchyTree = ({ id, version, hierarchyList }) => {
		return (

			hierarchyList.length ? <ul className="hier">
				{hierarchyList.map((hierarchy, index) => {
					if (index === 0) {
						return <li key={hierarchy + version + id} style={{ textIndent: index * 10 }}> {hierarchy}</li>
					}
					const tmpHierarchy = hierarchy.split(":")
					const entryVersion = tmpHierarchy[tmpHierarchy.length - 1]
					const entryName = hierarchy.replace(":" + entryVersion, "")
					const exclusionData = {
						title: "Exclude - issue:",
						domain: "security:transitive",
						transitive: true,
						libraryContent: {
							library: { name: entryName, language: report.dependency.library.language },
							version: entryVersion
						},
						content: {},
						report
					}
					return (
						<li key={hierarchy + version + id} className="hierarchy-entry" style={{ textIndent: index * 10 }}>&nbsp;└ {hierarchy}
							<button className="ml-3 btn btn-primary btn-action exclude-transitive"
								onClick={() => newMitigations("mitigated", exclusionData, false)}
							>Trust component</button>
						</li>
					)
				})}
			</ul> : null
		)
	}
	return (
		<div className={"tab-pane fade report-box-text" + (openTab === "hierarchy" ? " show active" : "")} id={"hierarchy-" + id} role="tabpanel" aria-labelledby={"hierarchy-tab-" + id} >
			<strong>Dependency graph for {report.dependency.library.name + ":" + report.dependency.version}:</strong>
			<div className="advice-hier">
				<HierarchyTree id={id} version={report.dependency.library.name + report.dependency.version} hierarchyList={report.hierarchy} />
			</div>
		</div>
	)
}

const Location = ({ openTab, report, id }) => {
	const ComponentLocation = ({ id, locationsList }) => {
		return (
			locationsList.length ? <ul>
				{locationsList.map(location => {
					return (
						<li key={id + "" + location}>{location}</li>
					)
				})
				}
			</ul> : null

		)
	}
	return (
		<div className={"tab-pane fade report-box-text" + (openTab === "locations" ? " show active" : "")} id={"location-" + id} role="tabpanel" aria-labelledby={"location-tab-" + id} >
			<ComponentLocation id={id} locationsList={report.locations} />
		</div>
	)
}

const Actions = ({ openTab, shouldShow, id, newMitigations, advicesData }) => {

	return (
		shouldShow.actions ?
			<div className={"tab-pane fade report-box-text" + (openTab === "actions" ? " show active" : "")} id={"actions-" + id} role="tabpanel" aria-labelledby={"actions-tab-" + id} >

				<button className="btn btn-primary btn-action issue-mitigate"
					title="This action is available only to authorized roles"
					onClick={() => { newMitigations("mitigated", advicesData[id], shouldShow.globalExclusion) }}>
					Mitigate
				</button> Provide a mitigation for this issue

				<br />

				<button className="btn btn-primary btn-action issue-mitigate"
					title="This action is available only to authorized roles"
					onClick={() => { newMitigations("unapplicable", advicesData[id], shouldShow.globalExclusion) }}>
					Unapplicable
				</button> Mark this issue as not applicable

				<br />

				<button className="btn btn-primary btn-action issue-mitigate"
					onClick={() => { newMitigations("invalid", advicesData[id], shouldShow.globalExclusion) }}>
					Report
				</button> Report this issue as incorrect

			</div>
			: ""
	)
}

const SysAdminPanel = ({ shouldShow, openTab, id, advice, showAdviceJson }) => {
	return (
		shouldShow.sysadminPanel ?
			<div className={"tab-pane fade report-box-text" + (openTab === "sysadmin" ? " show active" : "")} id={"sysadmin-" + id} role="tabpanel" aria-labelledby={"sysadmin-tab-" + id} >
				{showAdviceJson ? <ReactJson src={advice} /> : ""}
			</div>
			: ""
	)
}
const ChaiPanel = ({ shouldShow, openTab, id, advice, openChai }) => {
	const { uuid, branch } = useSelector((state) => state.projectInfo.report.project)
	const [ messages, setMessages ] = useState([])
	const adviceData = {
		advice: {
			cve: advice.cve, cvss: advice.cvss, cwe: advice.cwe, epss: advice.epss, library: advice.library,
			severity: advice.severity, id: advice.id, description: advice.description
		},
		projectUuid: uuid,
		branch 
	}
	return (
		<div className={"tab-pane fade" + (openTab === "chai" ? " show active" : "")} id={"chai-" + id} role="tabpanel" aria-labelledby={"chai-tab-" + id} >
			<Chai messages={messages} setMessages={setMessages} startChai={openChai} advice={adviceData}/>
		</div>
	)
}
export const Content = ({advice, advisoriesSCWContent}) => (
	advisoriesSCWContent && advisoriesSCWContent.name ?
		<React.Fragment>
			<p><b>{advisoriesSCWContent.name}</b> &nbsp;|&nbsp; <a href={`https://cwe.mitre.org/data/definitions/${advice.cwe.replace("CWE-", "")}.html`} className="text-link" target="_blank" rel="noopener noreferrer">{advice.cwe}</a></p>
			<p>{advisoriesSCWContent.description}</p>
			{advisoriesSCWContent.videos && advisoriesSCWContent.videos.length ?
				<video controls style={{ maxWidth: "100%" }}>
					<source src={advisoriesSCWContent.videos[0]}></source>
				</video> : ""
			}
			<p></p>
			{advisoriesSCWContent.scw ? <p>Learn more about this issue at <a href={advisoriesSCWContent.url} target="_blank" rel="noopener noreferrer" >Secure Code Warrior</a>.</p> : ""}
		</React.Fragment> :
		<React.Fragment>
			<p>Learn more about {advice.cwe} on the <a href={`https://cwe.mitre.org/data/definitions/${advice.cwe.replace("CWE-", "")}.html`} target="_blank" rel="noopener noreferrer">Mitre website</a></p>
		</React.Fragment>
)
export const Learn = ({ advice, openTab, advisoriesSCWContent, id, hasSecureCodeWarriorFeature }) => {

	//TEMPORARY
	if (!hasSecureCodeWarriorFeature) return ""

	return (
		advice.cwe && advice.cwe.length ?
			<div className={"tab-pane fade report-box-text position-relative" + (openTab === "scw" ? " show active" : "")} id={"learn-" + id} role="tabpanel" aria-labelledby={"learn-tab-" + id} >
				<Content advisoriesSCWContent={advisoriesSCWContent} advice={advice}/>
			</div> : ""
	)
}

let lastTabOpenedAt = null

const setlastTabOpenedAt = () => {
	lastTabOpenedAt = Date.now()
}

const didUserOpentab = () => {
	return Date.now() - lastTabOpenedAt > 200
}



const TabsList = ({id, advice, advisoriesSCWContent, setAdvisoriesSCWContent, shouldShow, setOpenTab, openTab, hasSecureCodeWarriorFeature, setOpenChai, setShowAdviceJson, }) => {
		const  { hasChaiFeature } = useSelector((state) => state.projectInfo.titleState)
		const fetchSCWContentForAdvice = async (cwe, language) => {
			cwe = cwe.replace("CWE-", "");
			if (advisoriesSCWContent.description.length) return;
			try {
				const request = await fetch("https://integration-api.securecodewarrior.com/api/v1/trial?Id=meterian&MappingList=cwe&MappingKey=" + cwe + "&LanguageKey=" + language)
				if (request.status !== 200) throw new Error("Request not accepted");
				const adviceContent = await request.json();
				setAdvisoriesSCWContent({ ...adviceContent, scw: true })
			}
			catch (e) {
				await fetchCWEInfo(cwe)
			}
		}

		const fetchCWEInfo = async (cwe) => {
			cwe = cwe.replace("CWE-", "");
			try {
				const request = await fetch("/api/v1/vulns/cwe/" + cwe, {
					headers: {
						"Authorization": "Bearer " + localStorage.accessToken
					}
				})
				if (request.status !== 200) throw new Error("Could not get CWE info from Meterian")
				const cweInfo = await request.json()
				setAdvisoriesSCWContent({ ...cweInfo, scw: false })
			}
			catch (e) {
				setAdvisoriesSCWContent({ scw: false, description: "Could not get additional information about this vulnerability" })
			}
		}

		const severity = advice.severity === "NONE" ? "INFO" : advice.severity
		const severityClass = "level-" + (shouldShow.exclusion ? "severity" : advice.severity.toLowerCase())
		return (
			<ul className="nav nav-tabs position-relative" id={id} role="tablist">

				{
					shouldShow.exclusion ? 
						<li className="nav-item tab-exclusion" 
							onClick={(e) => { if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("exclusion") }}
							id={"exclusion-tab-" + id} data-toggle="tab" href={"#mitigation-reason-" + id} role="tab" aria-controls={"mitigation-reason-" + id} aria-selected="true">
							<a className={"nav-link" + (openTab === "exclusion" ? " active" : "")} >Mitigation</a>
						</li> : 
						
						null
				}
				{
					advice.description ? 
						<li id={"description-tab-" + id} data-toggle="tab" href={"#description-" + id} role="tab" aria-controls={"description-" + id} aria-selected="true"
							className="nav-item tab-description" onClick={(e) => { if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("description") }}>
							<a className={"nav-link" + (openTab === "description" ? " active" : "")} >Description</a>
						</li> : null
				}
				{
					hasChaiFeature && shouldShow.chaiEnabled ? <li id={"chai-tab-" + id} data-toggle="tab" href={"#chai-" + id} role="tab" aria-controls={"chai-" + id} aria-selected="true"
						className="nav-item tab-chai" onClick={(e) => { if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("chai"); setOpenChai(true) }}>
						<a className={"nav-link" + (openTab === "chai" ? " active" : "")} >AI</a>
					</li> : null
				}
				{
					advice.links.length ?
						<li id={"info-tab-" + id} data-toggle="tab" href={"#info-" + id} role="tab" aria-controls={"info-" + id} aria-selected="false"
							className="nav-item tab-info" onClick={(e) => { if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("info") }}>
							<a className={"nav-link" + (openTab === "info" ? " active" : "")} >More Info</a>
						</li> :
						null
				}

				{
					shouldShow.hierarchy ? <li id={"hierarchy-tab-" + id} data-toggle="tab" href={"#hierarchy-" + id} role="tab" aria-controls={"hierarchy-" + id} aria-selected="false"
						className="nav-item tab-hierarchy" onClick={(e) => { if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("hierarchy") }}>
						<a className={"nav-link" + (openTab === "hierarchy" ? " active" : "")} >Hierarchy</a>
					</li> : ""
				}

				{shouldShow.locations ? <li id={"location-tab-" + id} data-toggle="tab" href={"#location-" + id} role="tab" aria-controls={"location-" + id} aria-selected="false"
					className="nav-item tab-locations" onClick={(e) => { if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("locations") }}>
					<a className={"nav-link" + (openTab === "locations" ? " active" : "")} >Locations</a>
				</li> : ""}
				{!shouldShow.exclusion && shouldShow.actions ? <li id={"action-tab-" + id} data-toggle="tab" href={"#actions-" + id} role="tab" aria-controls={"actions-" + id} aria-selected="false"
					className="nav-item tab-actions" onClick={(e) => { if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("actions") }}>
					<a className={"nav-link" + (openTab === "actions" ? " active" : "")} >Actions</a>
				</li> : ""}

				{hasSecureCodeWarriorFeature && advice.cwe && advice.cwe.length ? <li id={"learn-tab-" + id} data-toggle="tab" href={"#learn-" + id} role="tab" aria-controls={"learn-" + id} aria-selected="false"
					className="nav-item tab-scw" onClick={(e) => { fetchSCWContentForAdvice(advice.cwe, advice.library.language); if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("scw"); }} >
					<a className={"nav-link" + (openTab === "scw" ? " active" : "")} >Learn more...</a>
				</li> : ""}


				{shouldShow.sysadminPanel ? <li id={"sysadmin-tab-" + id} data-toggle="tab" href={"#sysadmin-" + id} role="tab" aria-controls={"sysadmin-" + id} aria-selected="false"
					className="nav-item tab-sysadmin" onClick={(e) => { setShowAdviceJson(true); if (!didUserOpentab()) { return }; setlastTabOpenedAt(); setOpenTab("sysadmin") }}>
					<a className={"nav-link" + (openTab === "sysadmin" ? " active" : "")} >SA</a>
				</li> : ""}


				<li className="nav-item position-absolute threat threat-tab" id={"threat" + id} role="tab">
					<span className="nav-link severity"  >
						{advice.type?
							<React.Fragment>
								{advice.severity.toLowerCase() !== "trusted" && advice.severity.toLowerCase() !== "none" ?
									<span ><small>THREAT:</small></span>
									:
									null
								}
								<strong className={severityClass}>
									{severity}
								</strong>
							</React.Fragment>
							:
							"SUGGESTION"
						}
					</span>
				</li>

			</ul>
		)
	}



const Advice = ({ id, hasSafeVersion, name, report, advice, shouldShow, newMitigations, removeMitigations, advicesData, hasSecureCodeWarriorFeature }) => {


	const [advisoriesSCWContent, setAdvisoriesSCWContent] = useState({ description: "" })
	const [showAdviceJson, setShowAdviceJson] = useState(false)
	const isExclusion = shouldShow.exclusion
	const [openTab, setOpenTab] = useState(isExclusion ? "exclusion" : "description")
	const [ openChai, setOpenChai] = useState(false)

	return (
		<div className="advice-wrapper" data-severity={shouldShow.exclusion ? "exclusion" : advice.severity.toLowerCase()} data-id={advice.id} key={id}>
			<TabsList id={id} advice={advice} advisoriesSCWContent={advisoriesSCWContent} setAdvisoriesSCWContent={setAdvisoriesSCWContent} shouldShow={shouldShow} setOpenTab={setOpenTab} openTab={openTab} hasSecureCodeWarriorFeature={hasSecureCodeWarriorFeature} setOpenChai={setOpenChai} setShowAdviceJson={setShowAdviceJson} advicesData={advicesData} openChai={openChai} hasSafeVersion={hasSafeVersion}/>
			<div className="tab-content" id={`${id}Content`}>
				<Exclusion openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} removeMitigations={removeMitigations} />
				<Description openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} name={name} />
				<Links hasSafeVersion = {hasSafeVersion} openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} />
				<Hierarchy openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} newMitigations={newMitigations} />
				<Location openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} />
				<Learn openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} advisoriesSCWContent={advisoriesSCWContent} hasSecureCodeWarriorFeature={hasSecureCodeWarriorFeature} />
				<Actions openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} newMitigations={newMitigations} advicesData={advicesData} />
				<SysAdminPanel openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} showAdviceJson={showAdviceJson} />
				<ChaiPanel openTab={openTab} id={id} report={report} advice={advice} shouldShow={shouldShow} openChai={openChai}/>
			</div>
		</div>
	)

}


export default Advice